import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=12ccdcc4&"
import script from "./trigger.vue?vue&type=script&lang=ts&"
export * from "./trigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports